<template>
    <div id="rangeSelectorDiv">
        <div id="minRangeSelectorDiv" class="rangeSelect">
            <div class="boundTitle">
                Min
             </div>
            <select id="minRangeBoundSelector" v-model="minRangeSelected">
                <option v-for="(rangeBound, index) in possibleRangeBounds" :value="rangeBound" v-bind:key="index" class="minRangeBoundOption" :disabled="rangeBound > maxRangeSelected">
                    {{ formatNumber(rangeBound) }}
                </option>
            </select>
        </div>
        <div id="maxBoundSelectorDiv" class="rangeSelect">
            <select id="maxBoundSelector" v-model="maxRangeSelected">
                <option v-for="(rangeBound, index) in possibleRangeBounds" :value="rangeBound" v-bind:key="index" class="maxRangeBoundOption" :disabled="rangeBound < minRangeSelected">
                    {{ formatNumber(rangeBound) }}
                </option>
            </select>
            <div class="boundTitle">
                Max
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'filterName',
        ],
        data () {
            return {
            }
        },
        computed: {
            minRangeSelected: {
                get() {
                    let selectedMin = this.$store.getters.getFilterSelectedByName(this.filterName).min;

                    if(selectedMin == null) {
                        selectedMin = this.defaultMinBound();
                    }

                    return selectedMin;
                    //return this.$store.getters.getFilterSelectedByName(this.filterName).min;
                },
                set(min) {
                    this.updateMaxList(min);
                }
            },
            maxRangeSelected: {
                get() {
                    let selectedMax = this.$store.getters.getFilterSelectedByName(this.filterName).max;

                    if(selectedMax == null) {
                        selectedMax = this.defaultMaxBound();
                    }

                    return selectedMax;
                    //return this.$store.getters.getFilterSelectedByName(this.filterName).max;
                },
                set(max) {
                    this.updateMinList(max);
                }
            },
            possibleRangeBounds() {
                let v = this.defaultMinBound();
                var possibleValues = [v];
                var incrementBy = (this.defaultMaxBound() - this.defaultMinBound()) < 1000 ? 1 : 1000;

                do {
                    if(incrementBy > 1) {
                        v = (Math.round(v / 1000) * 1000);

                        if(v < 4000) {
                            v = 4000;
                        }
                        else {
                            if(v == 10000) {
                                incrementBy = 2000;
                            }
                            else if(v == 30000) {
                                incrementBy = 5000;
                            }
                            else if(v == 50000) {
                                incrementBy = 10000;
                            }
                            else if(v == 100000) {
                                incrementBy = 200000;
                            }
                            else if(v == 900000) {
                                incrementBy = 100000000;
                            }
                        }
                    }

                    possibleValues.push(v);

                    if(v == 90000 && this.filterName == 'mileage') {
                        possibleValues.push(99000);
                    }
                    
                    v += incrementBy;
                } while (v < this.defaultMaxBound());

                possibleValues.push(this.defaultMaxBound());

                return possibleValues;
            }
        },
        methods: {
            defaultMinBound() {
                return this.$store.getters.getAvailableFilters[this.filterName].default.min;
            },
            defaultMaxBound() {
                return this.$store.getters.getAvailableFilters[this.filterName].default.max;
            },
            formatNumber: function (num) {
                var numFormated = "";
                
                if(num) {
                    if(this.filterName == 'price' || this.filterName == 'acv' || this.filterName == 'back_of_book') {
                        numFormated = "$";
                    } 
                    
                    if(this.filterName != 'year') {
                        numFormated += num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                    }
                    else {
                        numFormated = num;
                    }
                }
                else {
                    numFormated = 0;
                }
                
                return numFormated;
            },
            updateMaxList(min) {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('select_min', {'event_category': 'filter_selection','event_label': eventLabel});
                this.$store.commit('setRangeMinSelected', {name: this.filterName, value: min});
                
                if(this.$store.getters.getFilterSelectedByName(this.filterName).max == null) {
                    this.$store.commit('setRangeMaxSelected', {name: this.filterName, value: this.defaultMaxBound()});
                }

                this.$store.commit('notifySearchQueryChanges', true);
            },
            updateMinList(max) {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('select_max', {'event_category': 'filter_selection','event_label': eventLabel});
                this.$store.commit('setRangeMaxSelected', {name: this.filterName, value: max});

                if(this.$store.getters.getFilterSelectedByName(this.filterName).min == null) {
                    this.$store.commit('setRangeMinSelected', {name: this.filterName, value: this.defaultMinBound()});
                }

                this.$store.commit('notifySearchQueryChanges', true);
            }
        }
    }
</script>
<style>
    #rangeSelectorDiv {
        min-width: calc(28 * var(--vw));
        width: fit-content;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .inmobile #rangeSelectorDiv {
        height: inherit;
        width: inherit;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
    }

    .boundTitle {
        margin: calc(.5 * var(--vh));
    }

    .rangeSelect {
        width: fit-content;/*35%;*/
        text-align: right; 
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 calc(1 * var(--vw));
    }

    .inmobile .rangeSelect {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }

    .rangeSelect > select {
        width: fit-content; /*calc(100% - .4vw);*/
        font-size: 1.2em;
    }

    .inmobile .rangeSelect > select {
        font-size: 2em;
    }

    #rangeConnectorDiv {
        display: flex;
        align-items: center;
        font-weight: bolder;
        font-size: 2em;
    }

    .betweenArrow {
        transform: scale(2, 1.25);
    }
</style>